import React from "react";
import GoogleIcon from '@mui/icons-material/Google';
import { useGoogleLogin } from "@react-oauth/google";
import MicrosoftIcon from '@mui/icons-material/Microsoft';

import './OauthLoginBtn.css'
import { sendDataToApi } from "../../organisms/form/FormUtils";
import { useNavigate } from "react-router-dom";

interface props{
    microsoft: string
    google: string
}

const OauthLoginBtn = ({microsoft, google}: props)=>{
    const navigate = useNavigate();
    const googleOauthLogin = useGoogleLogin({
        onSuccess: async(tokenResponse)=>{
            let apiUrl = import.meta.env.VITE_GOOGLE_LOGIN_URL as string;
            sendDataToApi(apiUrl,"", {accessToken: tokenResponse.access_token}, navigate)
        },
        onError: (error)=>{
            console.log(error)
        }
    })

    return(
        <div className='oauthLoginContainer' >
            <button> <span><MicrosoftIcon /></span> {microsoft}</button>
            <button onClick={ () => googleOauthLogin()}> <span><GoogleIcon /></span> {google}</button>
        </div>
    )
}

export default OauthLoginBtn;